import { basePost, baseGet } from "../helpers/api";

export function postConfigAPI(name, setting) {
  const route = `/user/settings?appName=myq&settingName=${name}`;
  return basePost(route, setting);
}

export async function getConfigAPI(name) {
  const route = name
    ? `/user/settings?appName=myq&settingName=${name}`
    : '/user/settings?appName=myq';

  try {
    const data = await baseGet(route);
    return name ? data[name] : data;
  } catch (ex) {
    console.error('getConfigAPI error route', route, ex);
  }
}

export function deleteConfigAPI(name) {
  const route = `/user/settings?appName=myq&settingName=${name}`;
  return basePost(route, null);
}